// Launch-ready boilerplate legal copy. Replace with attorney-reviewed text before public launch
// (DRB-8 / launch checklist). Admin-editable via /content/pages once Firestore is live.
export interface LegalDoc {
  slug: string;
  title: string;
  updated: string;
  sections: Array<{ heading: string; body: string }>;
}

export const legalDocs: Record<string, LegalDoc> = {
  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    updated: "May 2026",
    sections: [
      {
        heading: "Overview",
        body: "DrBurns’ ReLeaf respects your privacy. This policy explains what information we collect, how we use it, and the choices you have.",
      },
      {
        heading: "Information we collect",
        body: "We collect information you provide at checkout (name, email, shipping address, phone) and standard analytics about how you use the site.",
      },
      {
        heading: "How we use it",
        body: "To fulfill orders, communicate about your purchases and subscriptions, improve the site, and — only with your consent — send marketing.",
      },
      {
        heading: "Your choices",
        body: "You can opt out of marketing at any time and request deletion of your account data by contacting orders@drburnsreleaf.com.",
      },
    ],
  },
  terms: {
    slug: "terms",
    title: "Terms of Service",
    updated: "May 2026",
    sections: [
      // DRB-4: 18 → 21, to match the age gate and the footer. A Terms page stating a lower
      // minimum than the control the site actually enforces is the document a challenge would cite.
      {
        heading: "Acceptance",
        body: "By using this site you agree to these terms. You must be 21 or older to purchase.",
      },
      {
        heading: "Products",
        body: "Our products are wellness supplements, not medications. They have not been evaluated by the FDA and are not intended to diagnose, treat, cure, or prevent any disease.",
      },
      {
        heading: "Orders & payment",
        body: "During launch, payment is completed by phone. We reserve the right to refuse or cancel any order.",
      },
    ],
  },
  shipping: {
    slug: "shipping",
    title: "Shipping Policy",
    updated: "May 2026",
    sections: [
      {
        heading: "Processing",
        body: "Orders placed before 2pm AZ time ship the same business day.",
      },
      {
        heading: "Delivery",
        body: "Most orders arrive within 3–5 business days. Orders ship at a $6.95 flat rate anywhere in the US.",
      },
      {
        heading: "Tracking",
        body: "A tracking number is emailed when your order ships.",
      },
    ],
  },
  returns: {
    slug: "returns",
    title: "Returns & Refunds",
    updated: "May 2026",
    sections: [
      {
        heading: "Satisfaction",
        body: "If you’re not satisfied, contact us within 30 days of delivery for a return or exchange.",
      },
      {
        heading: "How to start",
        body: "Email orders@drburnsreleaf.com with your order number and we’ll guide you through it.",
      },
    ],
  },
  disclaimer: {
    slug: "disclaimer",
    title: "FDA Disclaimer",
    updated: "May 2026",
    sections: [
      {
        heading: "Statement",
        body: "These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.",
      },
      {
        heading: "Consult your physician",
        body: "Always consult your physician or veterinarian before beginning any new wellness routine, especially if you are pregnant, nursing, or taking medication.",
      },
    ],
  },
};
